import { Select } from "antd";
const { Option } = Select;

export default function SelectLabel({
  label,
  onChange,
  placeholder,
  options,
  value,
  name,
  error,
  style,
}) {
  const handleChange = (val) => {
    onChange({ target: { name, value: val } });
  };

  return (
    <div>
      <div className={`inputLabel ${error && "error"} `}>{label}</div>
      <Select
        showSearch
        value={value}
        style={{ width: "100%", ...style }}
        placeholder={placeholder}
        onChange={handleChange}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {options.map((o, i) => (
          <Option key={i} value={o.value}>
            {o.text}
          </Option>
        ))}
      </Select>
    </div>
  );
}
